(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        document.body.classList.remove('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["helpdesk"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      // DOM elements
      const topicGrid = document.getElementById('topic-grid');
      const topicCards = document.querySelectorAll('.topic-card'); // Selects all cards including redirect links
      const pageContentContainer = document.getElementById('page-content-container');
      
      // Content display areas within pageContentContainer
      const embeddedPageContent = document.getElementById('embedded-page-content'); // For fetched pages
      const embeddedPageContainer = document.getElementById('embedded-page-container'); // Actual content of fetched page
      const richTextEmbedDisplay = document.getElementById('rich-text-embed-display'); // For embedded rich text

      const backButtons = document.querySelectorAll('[data-action="back-to-home"]');
      const pageHeaderElement = document.querySelector('.page-header'); // Get the .page-header element
      const helpdeskContainer = document.querySelector('.helpdesk-container');
      const helpdeskMain = document.querySelector('.helpdesk-main');
      // const initialTopicsHeading = helpdeskMain.getAttribute('data-topics-heading'); // No longer used for display

      // UI Text from data attributes
      const uiText = {
        breadcrumbHomeLabel: helpdeskMain.dataset.breadcrumbHomeLabel || '',
        loadingMessageLabel: helpdeskMain.dataset.loadingMessageLabel || '',
        errorLoadingPageLabel: helpdeskMain.dataset.errorLoadingPageLabel || '',
        errorEmptyPageLabel: helpdeskMain.dataset.errorEmptyPageLabel || '',
        errorContentNotFoundLabel: helpdeskMain.dataset.errorContentNotFoundLabel || '',
        openPageDirectlyLabel: helpdeskMain.dataset.openPageDirectlyLabel || '',
        consoleTipLabel: helpdeskMain.dataset.consoleTipLabel || ''
      };

      let allHelpdeskItems = [];
      const helpdeskDataElement = document.getElementById('helpdesk-items-data');
      if (helpdeskDataElement) {
        try {
          allHelpdeskItems = JSON.parse(helpdeskDataElement.textContent);
        } catch (e) {
          console.error("Error parsing helpdesk items JSON data from DOM:", e);
        }
      } else {
        console.error("Helpdesk data element #helpdesk-items-data not found.");
      }

      
      function normalizePath(path) {
        const normalized = String(path || '/').replace(/\/{2,}/g, '/').replace(/\/+$/, '');
        return normalized || '/';
      }

      function decodeRouteSegment(segment) {
        try {
          return decodeURIComponent(segment);
        } catch (_) {
          return segment;
        }
      }

      function normalizeSegment(value) {
        return String(value || '')
          .trim()
          .toLowerCase()
          .replace(/^\/+|\/+$/g, '')
          .replace(/\s+/g, '-');
      }

      function splitRoutePath(pathLike) {
        const raw = String(pathLike || '').replace(/^\/+|\/+$/g, '');
        if (!raw) return [];
        return raw
          .split('/')
          .map((part) => normalizeSegment(decodeRouteSegment(part)))
          .filter(Boolean);
      }

      function slugify(value) {
        let source = String(value || '').trim().toLowerCase();
        try {
          source = source.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        } catch (_) {
          // no-op: keep original source if normalize is not available
        }
        return source
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }

      function getPathnameFromUrl(urlValue) {
        if (!urlValue) return '';
        try {
          return new URL(urlValue, window.location.origin).pathname || '';
        } catch (_) {
          return String(urlValue);
        }
      }

      function getHelpdeskItemById(itemId) {
        const normalizedId = String(itemId || '');
        return allHelpdeskItems.find((item) => String(item.id || '') === normalizedId) || null;
      }

      function getHelpdeskItemByCardElement(cardElement) {
        if (!cardElement) return null;
        return getHelpdeskItemById(cardElement.dataset.blockId);
      }

      function getItemOwnFolderHandle(item) {
        if (!item || item.type !== 'folder') return '';
        return normalizeSegment(item.handle);
      }

      function getItemParentFolderHandle(item) {
        if (!item) return '';
        if (item.type === 'folder') {
          return normalizeSegment(item.parent_folder_handle);
        }
        return normalizeSegment(item.parent_folder_handle || item.handle);
      }

      function getItemRouteSlug(item) {
        if (!item) return '';
        if (item.type === 'folder') {
          return getItemOwnFolderHandle(item);
        }

        const configuredRouteSlug = normalizeSegment(item.route_slug);
        if (configuredRouteSlug) {
          return configuredRouteSlug;
        }

        if (item.type === 'page_link') {
          const pathname = getPathnameFromUrl(item.page_url);
          const parts = pathname.split('/').filter(Boolean);
          const pageHandle = parts.length ? parts[parts.length - 1] : '';
          return normalizeSegment(pageHandle) || slugify(item.title) || normalizeSegment(item.id);
        }

        return slugify(item.title) || normalizeSegment(item.id);
      }

      function getCardParentFolderHandle(cardElement) {
        if (!cardElement) return '';
        if (cardElement.dataset.type === 'folder') {
          return normalizeSegment(cardElement.dataset.parentFolder);
        }
        return normalizeSegment(cardElement.dataset.folder);
      }

      function getFolderItemByHandleAndParent(folderHandle, parentFolderHandle) {
        const normalizedFolderHandle = normalizeSegment(folderHandle);
        const normalizedParentFolderHandle = normalizeSegment(parentFolderHandle);
        return (
          allHelpdeskItems.find(
            (item) =>
              item.type === 'folder' &&
              getItemOwnFolderHandle(item) === normalizedFolderHandle &&
              getItemParentFolderHandle(item) === normalizedParentFolderHandle
          ) || null
        );
      }

      function buildFolderTrailFromFolderItem(folderItem) {
        if (!folderItem || folderItem.type !== 'folder') return [];

        const trail = [];
        let currentItem = folderItem;
        let safety = 0;

        while (currentItem && safety < 20) {
          trail.unshift({
            handle: getItemOwnFolderHandle(currentItem),
            title: currentItem.title || currentItem.handle || getItemOwnFolderHandle(currentItem)
          });

          const parentHandle = getItemParentFolderHandle(currentItem);
          if (!parentHandle) break;

          currentItem =
            allHelpdeskItems.find(
              (item) => item.type === 'folder' && getItemOwnFolderHandle(item) === parentHandle
            ) || null;
          safety += 1;
        }

        return trail;
      }

      function sanitizeFolderTrail(trail) {
        if (!Array.isArray(trail)) return [];
        return trail
          .map((entry) => {
            const handle = normalizeSegment(entry && entry.handle);
            const title = String((entry && entry.title) || handle || '').trim();
            return handle ? { handle, title } : null;
          })
          .filter(Boolean);
      }

      function findCardElementByItemId(itemId) {
        const normalizedId = String(itemId || '');
        return Array.from(topicCards).find((card) => String(card.dataset.blockId || '') === normalizedId) || null;
      }

      // STATE
      let currentFolderTrail = [];
      let currentArticleTitle = null;
      let currentArticleSlug = null;
      const breadcrumbsContainer = document.getElementById('helpdesk-breadcrumbs');

      function getCurrentFolderHandle() {
        if (!currentFolderTrail.length) return '';
        return currentFolderTrail[currentFolderTrail.length - 1].handle;
      }

      function getCurrentRouteSegments() {
        const folderSegments = currentFolderTrail.map((entry) => normalizeSegment(entry.handle)).filter(Boolean);
        if (currentArticleSlug) folderSegments.push(currentArticleSlug);
        return folderSegments;
      }

      function getBaseHelpPath() {
        const configuredBasePath = normalizePath(helpdeskMain.dataset.helpBasePath || '/pages/help');
        const currentPath = normalizePath(window.location.pathname);

        if (currentPath === configuredBasePath || currentPath.startsWith(configuredBasePath + '/')) {
          return configuredBasePath;
        }

        const configuredParts = configuredBasePath.split('/').filter(Boolean);
        const currentParts = currentPath.split('/').filter(Boolean);
        if (!configuredParts.length) {
          return configuredBasePath;
        }

        for (let index = 0; index <= currentParts.length - configuredParts.length; index += 1) {
          const matches = configuredParts.every(
            (configuredPart, partOffset) => currentParts[index + partOffset] === configuredPart
          );
          if (matches) {
            return '/' + currentParts.slice(0, index + configuredParts.length).join('/');
          }
        }

        return configuredBasePath;
      }

      const helpBasePath = getBaseHelpPath();

      function buildRoutePathValue(routeSegments) {
        const segments = (Array.isArray(routeSegments) ? routeSegments : [])
          .map((segment) => normalizeSegment(segment))
          .filter(Boolean);

        return segments.join('/');
      }

      function encodeRouteValueForQuery(routePathValue) {
        return encodeURIComponent(String(routePathValue || '')).replace(/%2F/gi, '/');
      }

      function decodeQueryComponentForMatch(value) {
        try {
          return decodeURIComponent(String(value || '').replace(/\+/g, '%20'));
        } catch (_) {
          return String(value || '');
        }
      }

      function buildSearchWithUpdatedRouteParam(currentSearch, routePathValue) {
        const query = String(currentSearch || '').replace(/^\?/, '');
        if (!query) {
          return routePathValue ? `h=${encodeRouteValueForQuery(routePathValue)}` : '';
        }

        const rawEntries = query.split('&').filter((entry) => entry !== '');
        const outputEntries = [];
        let routeParamHandled = false;

        rawEntries.forEach((rawEntry) => {
          const equalsIndex = rawEntry.indexOf('=');
          const rawKey = equalsIndex === -1 ? rawEntry : rawEntry.slice(0, equalsIndex);
          const rawValue = equalsIndex === -1 ? '' : rawEntry.slice(equalsIndex + 1);
          const decodedKey = decodeQueryComponentForMatch(rawKey);

          if (decodedKey === 'h') {
            if (!routeParamHandled && routePathValue) {
              outputEntries.push(`h=${encodeRouteValueForQuery(routePathValue)}`);
              routeParamHandled = true;
            }
            return;
          }

          if (equalsIndex === -1) {
            outputEntries.push(rawKey);
          } else {
            outputEntries.push(`${rawKey}=${rawValue}`);
          }
        });

        if (routePathValue && !routeParamHandled) {
          outputEntries.push(`h=${encodeRouteValueForQuery(routePathValue)}`);
        }

        return outputEntries.join('&');
      }

      function syncUrlWithCurrentState(options = {}) {
        if (!window.history || !window.history.pushState) return;

        const replaceHistory = Boolean(options.replace);
        const routePathValue = buildRoutePathValue(getCurrentRouteSegments());
        const targetPath = normalizePath(helpBasePath);

        const search = buildSearchWithUpdatedRouteParam(window.location.search || '', routePathValue);
        const targetUrl = search ? `${helpBasePath}?${search}` : helpBasePath;
        const currentPath = normalizePath(window.location.pathname);
        const currentUrl = window.location.pathname + window.location.search;

        if (currentPath === targetPath && currentUrl === targetUrl) return;

        const state = { helpdeskRoute: true };
        if (replaceHistory) {
          window.history.replaceState(state, '', targetUrl);
        } else {
          window.history.pushState(state, '', targetUrl);
        }
      }

      function getRouteSegmentsFromLocation() {
        const searchParams = new URLSearchParams(window.location.search || '');
        const routeFromQuery = searchParams.get('h');
        if (routeFromQuery) return splitRoutePath(routeFromQuery);

        return [];
      }

      function resolveRouteSegments(routeSegments) {
        const normalizedSegments = (Array.isArray(routeSegments) ? routeSegments : [])
          .map((segment) => normalizeSegment(segment))
          .filter(Boolean);

        if (!normalizedSegments.length) {
          return { type: 'home' };
        }

        const folderTrailItems = [];
        let currentParentHandle = '';

        for (let index = 0; index < normalizedSegments.length; index += 1) {
          const segment = normalizedSegments[index];
          const isLastSegment = index === normalizedSegments.length - 1;

          const matchingFolder = getFolderItemByHandleAndParent(segment, currentParentHandle);
          const matchingArticle =
            allHelpdeskItems.find(
              (item) =>
                item.type !== 'folder' &&
                getItemParentFolderHandle(item) === currentParentHandle &&
                getItemRouteSlug(item) === segment
            ) || null;

          if (!isLastSegment) {
            if (!matchingFolder) return null;
            folderTrailItems.push(matchingFolder);
            currentParentHandle = getItemOwnFolderHandle(matchingFolder);
            continue;
          }

          if (matchingArticle) {
            return {
              type: 'article',
              item: matchingArticle,
              folderTrail: folderTrailItems.map((folderItem) => ({
                handle: getItemOwnFolderHandle(folderItem),
                title: folderItem.title || folderItem.handle || getItemOwnFolderHandle(folderItem)
              }))
            };
          }

          if (matchingFolder) {
            folderTrailItems.push(matchingFolder);
            return {
              type: 'folder',
              folderTrail: folderTrailItems.map((folderItem) => ({
                handle: getItemOwnFolderHandle(folderItem),
                title: folderItem.title || folderItem.handle || getItemOwnFolderHandle(folderItem)
              }))
            };
          }

          return null;
        }

        return null;
      }

      function applyRouteFromLocation(options = {}) {
        const requestedSegments = getRouteSegmentsFromLocation();
        let resolvedRoute = null;
        let resolvedDepth = requestedSegments.length;

        for (let depth = requestedSegments.length; depth >= 0; depth -= 1) {
          const candidateRoute = resolveRouteSegments(requestedSegments.slice(0, depth));
          if (candidateRoute) {
            resolvedRoute = candidateRoute;
            resolvedDepth = depth;
            break;
          }
        }

        const routeWasTrimmed = resolvedDepth < requestedSegments.length;
        const normalizedOptions = routeWasTrimmed
          ? { ...options, replaceHistory: true, skipUrlUpdate: false }
          : options;

        if (!resolvedRoute) {
          showHome({ replaceHistory: true, skipUrlUpdate: false });
          return false;
        }

        if (resolvedRoute.type === 'home') {
          showHome(normalizedOptions);
          return true;
        }

        if (resolvedRoute.type === 'folder') {
          const folderTrail = sanitizeFolderTrail(resolvedRoute.folderTrail);
          const targetFolder = folderTrail[folderTrail.length - 1];
          if (!targetFolder) {
            showHome({ replaceHistory: true, skipUrlUpdate: false });
            return false;
          }
          showFolderContents(targetFolder.handle, targetFolder.title, { ...normalizedOptions, folderTrail });
          return true;
        }

        if (resolvedRoute.type === 'article' && resolvedRoute.item) {
          const targetItem = resolvedRoute.item;
          const folderTrail = sanitizeFolderTrail(resolvedRoute.folderTrail);

          if (targetItem.type === 'page_link' && (targetItem.link_behavior || 'embed') === 'redirect') {
            if (targetItem.page_url) {
              window.location.href = targetItem.page_url;
              return true;
            }
            showHome({ replaceHistory: true, skipUrlUpdate: false });
            return false;
          }

          const cardElement = findCardElementByItemId(targetItem.id);
          if (!cardElement) {
            showHome({ replaceHistory: true, skipUrlUpdate: false });
            return false;
          }

          if (targetItem.type === 'page_link') {
            showPage(targetItem.page_url, cardElement, { ...normalizedOptions, folderTrail });
            return true;
          }

          if (targetItem.type === 'embedded_rich_text') {
            showRichTextContent(targetItem.id, cardElement, { ...normalizedOptions, folderTrail });
            return true;
          }
        }

        showHome({ replaceHistory: true, skipUrlUpdate: false });
        return false;
      }

      // BREADCRUMB HELPER FUNCTIONS
      function createBreadcrumbLink(text, onClickHandler) {
        const link = document.createElement('a');
        link.href = '#';
        link.textContent = text;
        link.addEventListener('click', (e) => {
          e.preventDefault();
          onClickHandler();
        });
        return link;
      }

      function createBreadcrumbSeparator() {
        const separator = document.createElement('span');
        separator.className = 'separator';
        separator.textContent = '/';
        return separator;
      }

      function createCurrentPageSpan(text) {
        const span = document.createElement('span');
        span.className = 'current-page';
        span.textContent = text;
        return span;
      }

      // UPDATE BREADCRUMBS FUNCTION
      function updateBreadcrumbs() {
        if (!breadcrumbsContainer) return;
        breadcrumbsContainer.innerHTML = '';

        const homeLink = createBreadcrumbLink(uiText.breadcrumbHomeLabel, showHome);
        breadcrumbsContainer.appendChild(homeLink);

        if (currentFolderTrail.length) {
          currentFolderTrail.forEach((folderEntry, index) => {
            const isLastFolder = index === currentFolderTrail.length - 1;
            breadcrumbsContainer.appendChild(createBreadcrumbSeparator());

            if (isLastFolder && !currentArticleTitle) {
              breadcrumbsContainer.appendChild(createCurrentPageSpan(folderEntry.title));
              return;
            }

            const targetTrail = currentFolderTrail.slice(0, index + 1);
            breadcrumbsContainer.appendChild(
              createBreadcrumbLink(folderEntry.title, () => {
                const targetFolder = targetTrail[targetTrail.length - 1];
                showFolderContents(targetFolder.handle, targetFolder.title, { folderTrail: targetTrail });
              })
            );
          });
        }

        if (currentArticleTitle) {
          breadcrumbsContainer.appendChild(createBreadcrumbSeparator());
          breadcrumbsContainer.appendChild(createCurrentPageSpan(currentArticleTitle));
        }

        if (pageHeaderElement) {
          if (currentFolderTrail.length || currentArticleTitle) {
            pageHeaderElement.style.display = 'block';
          } else {
            pageHeaderElement.style.display = 'none';
          }
        }
      }
      

      function showFolderContents(folderHandle, folderTitle, options = {}) {
        const normalizedFolderHandle = normalizeSegment(folderHandle);
        if (!normalizedFolderHandle) {
          showHome(options);
          return;
        }

        const trailFromOptions = sanitizeFolderTrail(options.folderTrail);
        if (trailFromOptions.length) {
          currentFolderTrail = trailFromOptions;
        } else {
          currentFolderTrail = [{ handle: normalizedFolderHandle, title: String(folderTitle || normalizedFolderHandle) }];
        }

        currentArticleTitle = null;
        currentArticleSlug = null;

        pageContentContainer.classList.add('hidden');
        embeddedPageContent.style.display = 'none';
        richTextEmbedDisplay.style.display = 'none';
        revertBodyClasses();

        topicGrid.classList.remove('hidden');

        const activeFolderHandle = getCurrentFolderHandle();

        topicCards.forEach(card => {
          const cardType = card.dataset.type;
          const parentFolderHandle = getCardParentFolderHandle(card);

          if (parentFolderHandle === activeFolderHandle) {
            card.classList.remove('item-in-folder');
            card.style.display = 'flex';
          } else {
            if (cardType !== 'folder') {
              card.classList.add('item-in-folder');
            }
            card.style.display = 'none';
          }
        });

        scrollToHelpdeskTop();
        maintainConsistentLayout();
        if (!options.skipUrlUpdate) {
          syncUrlWithCurrentState({ replace: options.replaceHistory });
        }
        updateBreadcrumbs();
      }

      function showHome(options = {}) {
        currentFolderTrail = [];
        currentArticleTitle = null;
        currentArticleSlug = null;

        pageContentContainer.classList.add('hidden');
        embeddedPageContent.style.display = 'none';
        richTextEmbedDisplay.style.display = 'none';
        revertBodyClasses();

        topicGrid.classList.remove('hidden');

        topicCards.forEach(card => {
          const cardType = card.dataset.type;
          const parentFolderHandle = getCardParentFolderHandle(card);
          const isTopLevel = parentFolderHandle === '';

          if (isTopLevel) {
            card.style.display = 'flex';
            card.classList.remove('item-in-folder');
          } else {
            card.style.display = 'none';
            if (cardType !== 'folder') {
              card.classList.add('item-in-folder');
            }
          }
        });

        scrollToHelpdeskTop();
        maintainConsistentLayout();
        if (!options.skipUrlUpdate) {
          syncUrlWithCurrentState({ replace: options.replaceHistory });
        }
        updateBreadcrumbs();
      }
      
      // Helper function to scroll to the top of the helpdesk
      function scrollToHelpdeskTop() {
        if (helpdeskContainer) {
          const headerOffset = 120; // Adjust as needed for your sticky header
          const elementPosition = helpdeskMain.getBoundingClientRect().top; // Scroll to top of main content area
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }
      
      // --- Layout/height handling for embedded content ---
      // We keep a baseline min-height so the page doesn't jump during transitions,
      // but we calculate it from *layout-real* heights (offsetHeight), not scrollHeight.
      // scrollHeight can include absolutely-positioned or hidden content and can create "dead space".
      let helpdeskLayoutObserversInitialized = false;
      let helpdeskLayoutResizeObserver = null;
      let helpdeskLayoutMutationObserver = null;
      let helpdeskLayoutRaf = null;

      function scheduleMaintainConsistentLayout() {
        if (helpdeskLayoutRaf) cancelAnimationFrame(helpdeskLayoutRaf);
        helpdeskLayoutRaf = requestAnimationFrame(() => {
          helpdeskLayoutRaf = null;
          try {
            maintainConsistentLayout();
          } catch (_) {
            // no-op
          }
        });
      }

      function setupDynamicLayoutObservers() {
        // Can be called multiple times (after content injection); initialize once.
        if (helpdeskLayoutObserversInitialized) {
          scheduleMaintainConsistentLayout();
          return;
        }
        helpdeskLayoutObserversInitialized = true;

        // ResizeObserver reacts to async content changes (images, video embeds, accordions, apps)
        if ('ResizeObserver' in window) {
          helpdeskLayoutResizeObserver = new ResizeObserver(() => scheduleMaintainConsistentLayout());
          [topicGrid, pageContentContainer, embeddedPageContainer, richTextEmbedDisplay].forEach((el) => {
            if (!el) return;
            try { helpdeskLayoutResizeObserver.observe(el); } catch (_) {}
          });
        }

        // MutationObserver catches DOM injections that don't trigger a resize immediately
        if ('MutationObserver' in window) {
          helpdeskLayoutMutationObserver = new MutationObserver(() => scheduleMaintainConsistentLayout());
          const config = { childList: true, subtree: true, attributes: true, characterData: true };
          if (embeddedPageContainer) helpdeskLayoutMutationObserver.observe(embeddedPageContainer, config);
          if (richTextEmbedDisplay) helpdeskLayoutMutationObserver.observe(richTextEmbedDisplay, config);
        }

        // Media load events don't bubble, but we can capture them to recalc after lazy assets load
        if (helpdeskContainer) {
          const onMediaEvent = () => scheduleMaintainConsistentLayout();
          helpdeskContainer.addEventListener('load', onMediaEvent, true);
          helpdeskContainer.addEventListener('error', onMediaEvent, true);
          helpdeskContainer.addEventListener('loadedmetadata', onMediaEvent, true);
        }

        scheduleMaintainConsistentLayout();
      }

      function maintainConsistentLayout() {
        const defaultMinHeight = 500; // Match .helpdesk-main CSS baseline
        if (!helpdeskMain) return;

        let currentContentHeight = 0;

        const isGridVisible = topicGrid && !topicGrid.classList.contains('hidden');
        const isPageVisible = pageContentContainer && !pageContentContainer.classList.contains('hidden');

        if (isGridVisible) {
          currentContentHeight = topicGrid.offsetHeight || 0;
        } else if (isPageVisible) {
          currentContentHeight = pageContentContainer.offsetHeight || 0;
        }

        // Fallback (rare): if height is still 0 while visible, try inner container
        if (currentContentHeight === 0 && isPageVisible && embeddedPageContainer) {
          currentContentHeight = embeddedPageContainer.offsetHeight || 0;
        }

        const dynamicMinHeight = Math.max(defaultMinHeight, currentContentHeight);
        helpdeskMain.style.minHeight = dynamicMinHeight + 'px';
      }

      // Executes inline and external scripts contained within a container that had HTML injected
      function executeScriptsInContainer(container) {
        if (!container) return;

        const isScriptAlreadyLoaded = (src) => {
          try {
            const absoluteSrc = new URL(src, window.location.href).href;
            return Array.from(document.scripts).some((s) => {
              if (!s.src) return false;
              try {
                return new URL(s.src, window.location.href).href === absoluteSrc;
              } catch (_) {
                return false;
              }
            });
          } catch (_) {
            return false;
          }
        };

        const scripts = container.querySelectorAll('script');
        scripts.forEach((oldScript) => {
          const typeAttr = (oldScript.getAttribute('type') || '').trim();
          const isModule = typeAttr === 'module';
          const isExecutable = !typeAttr || typeAttr === 'text/javascript' || typeAttr === 'application/javascript' || isModule;
          if (!isExecutable) return; // Skip non-executable script tags like application/json templates

          const newScript = document.createElement('script');
          // Copy attributes
          Array.from(oldScript.attributes).forEach(({ name, value }) => newScript.setAttribute(name, value));

          if (oldScript.src) {
            const src = oldScript.getAttribute('src');
            if (src && !isScriptAlreadyLoaded(src)) {
              newScript.src = src;
              newScript.async = false; // Preserve execution order
              oldScript.parentNode.insertBefore(newScript, oldScript.nextSibling);
            }
            // Remove the placeholder old script regardless
            oldScript.remove();
          } else {
            // Inline script
            newScript.textContent = oldScript.textContent;
            oldScript.parentNode.insertBefore(newScript, oldScript.nextSibling);
            oldScript.remove();
          }
        });
      }

      // Dispatch common init events many Shopify apps listen to after dynamic DOM injections
      function dispatchAppInitEvents(targetContainer) {
        try {
          const container = targetContainer || embeddedPageContainer || document.body;
          // Shopify section load event (many themes/apps re-initialize on this)
          const sectionLoad = new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: 'helpdesk-embedded', container } });
          container.dispatchEvent(sectionLoad);

          // Generic page load style events
          document.dispatchEvent(new Event('page:load'));
          document.dispatchEvent(new Event('page:loaded'));

          // Turbo/Turbolinks style event (some apps hook into it)
          document.dispatchEvent(new Event('turbo:load'));

          // Custom hook for debugging/integration
          const helpdeskMounted = new CustomEvent('helpdesk:content:mounted', { detail: { container } });
          container.dispatchEvent(helpdeskMounted);
        } catch (err) {
          console.warn('Helpdesk: dispatchAppInitEvents failed', err);
        }
      }

      // Track injected head resources to avoid duplicates
      const injectedStylesheetHrefs = new Set(Array.from(document.head.querySelectorAll('link[rel="stylesheet"]')).map((l) => { try { return new URL(l.href, location.href).href; } catch (_) { return l.href; } }));
      const injectedInlineStyleSignatures = new Set();

      function injectStylesFromDocument(doc) {
        if (!doc || !doc.head) return;

        // Inject external stylesheets
        const linkNodes = doc.head.querySelectorAll('link[rel="stylesheet"], link[rel="preload"][as="style"]');
        linkNodes.forEach((link) => {
          const href = link.getAttribute('href');
          if (!href) return;
          let absHref;
          try { absHref = new URL(href, location.href).href; } catch (_) { absHref = href; }
          if (injectedStylesheetHrefs.has(absHref)) return;

          const newLink = document.createElement('link');
          Array.from(link.attributes).forEach(({ name, value }) => newLink.setAttribute(name, value));
          if (newLink.rel === 'preload' && newLink.getAttribute('as') === 'style') {
            newLink.rel = 'stylesheet';
            newLink.removeAttribute('as');
          }
          newLink.href = absHref;
          newLink.addEventListener('load', () => {
            if (typeof maintainConsistentLayout === 'function') maintainConsistentLayout();
          });
          document.head.appendChild(newLink);
          injectedStylesheetHrefs.add(absHref);
        });

        // Inject inline <style> tags from head (dedupe by simple signature)
        const styleNodes = doc.head.querySelectorAll('style');
        styleNodes.forEach((styleNode) => {
          const signature = (styleNode.textContent || '').trim().slice(0, 500);
          if (!signature || injectedInlineStyleSignatures.has(signature)) return;
          const newStyle = document.createElement('style');
          Array.from(styleNode.attributes).forEach(({ name, value }) => newStyle.setAttribute(name, value));
          newStyle.setAttribute('data-helpdesk-inline-style', 'true');
          newStyle.textContent = styleNode.textContent;
          document.head.appendChild(newStyle);
          injectedInlineStyleSignatures.add(signature);
        });
      }

      // Apply and restore body classes from fetched page to improve CSS targeting
      let helpdeskAddedBodyClasses = new Set();
      function applyBodyClassesFrom(doc) {
        try {
          if (!doc || !doc.body) return;
          // Remove previously added classes before applying new ones
          revertBodyClasses();
          const hostBody = document.body;
          const incoming = Array.from(doc.body.classList || []);
          incoming.forEach((cls) => {
            if (!hostBody.classList.contains(cls)) {
              hostBody.classList.add(cls);
              helpdeskAddedBodyClasses.add(cls);
            }
          });
        } catch (e) {
          console.warn('Helpdesk: applyBodyClassesFrom failed', e);
        }
      }

      function revertBodyClasses() {
        try {
          if (!helpdeskAddedBodyClasses || helpdeskAddedBodyClasses.size === 0) return;
          const hostBody = document.body;
          helpdeskAddedBodyClasses.forEach((cls) => hostBody.classList.remove(cls));
          helpdeskAddedBodyClasses.clear();
        } catch (e) {
          console.warn('Helpdesk: revertBodyClasses failed', e);
        }
      }
      
      // Shows a fetched page in the embedded container
      function showPage(url, cardElement, options = {}) {
        const topicGrid = document.getElementById('topic-grid');
        const pageContentContainer = document.getElementById('page-content-container');
        const embeddedPageContent = document.getElementById('embedded-page-content'); 
        const embeddedPageContainer = document.getElementById('embedded-page-container'); 
        const richTextEmbedDisplay = document.getElementById('rich-text-embed-display');
        const helpdeskMain = document.querySelector('.helpdesk-main'); // For maintainConsistentLayout if used

        const cardTitleText = cardElement.querySelector('.topic-card-title').textContent.trim();
        const selectedItem = getHelpdeskItemByCardElement(cardElement);
        const trailFromOptions = sanitizeFolderTrail(options.folderTrail);
        if (trailFromOptions.length) {
          currentFolderTrail = trailFromOptions;
        } else {
          const parentFolderHandle = selectedItem ? getItemParentFolderHandle(selectedItem) : '';
          const activeFolderHandle = getCurrentFolderHandle();
          if (!parentFolderHandle) {
            currentFolderTrail = [];
          } else if (parentFolderHandle !== activeFolderHandle) {
            const parentFolderItem = allHelpdeskItems.find(
              (item) => item.type === 'folder' && getItemOwnFolderHandle(item) === parentFolderHandle
            );
            currentFolderTrail = buildFolderTrailFromFolderItem(parentFolderItem);
          }
        }

        currentArticleTitle = cardTitleText;
        currentArticleSlug = selectedItem ? getItemRouteSlug(selectedItem) : slugify(cardTitleText);

        topicGrid.classList.add('hidden');
        // Reset any previously applied body classes from other embedded pages while loading new content
        revertBodyClasses();
        
        embeddedPageContainer.innerHTML = `<div class="loading">${uiText.loadingMessageLabel}</div>`;
        
        richTextEmbedDisplay.style.display = 'none'; 
        embeddedPageContent.style.display = 'block'; 
        pageContentContainer.classList.remove('hidden');

        // Immediately recalc layout so we don't keep an old (too large) min-height during slow fetches
        if (typeof setupDynamicLayoutObservers === 'function') {
          setupDynamicLayoutObservers();
        }
        if (typeof scheduleMaintainConsistentLayout === 'function') {
          scheduleMaintainConsistentLayout();
        } else if (typeof maintainConsistentLayout === 'function') {
          maintainConsistentLayout();
        }
        
        scrollToHelpdeskTop();
        
        fetch(url)
          .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
          })
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            const selectorsToTry = [
                'main#MainContent',
                '#MainContent',
                '.shopify-policy__container',
                'article.page',
                'main .page-content',
                '.page-content',
                'main',
                'main#MainContent .rte',
                '#MainContent .rte',
                '.shopify-policy__container .rte',
                'main .page-content .rte',
                'main .rte',
                '.page-content .rte',
                'article.page .rte'
            ];

            let contentElement = null;
            for (let selector of selectorsToTry) {
                contentElement = doc.querySelector(selector);
                if (contentElement) {
                    break;
                }
            }

            if (contentElement) {
              // Bring in styles and body classes from the fetched page to preserve appearance
              injectStylesFromDocument(doc);
              applyBodyClassesFrom(doc);

              embeddedPageContainer.innerHTML = contentElement.outerHTML;
              // Execute scripts and re-run app initializers for embedded content
              executeScriptsInContainer(embeddedPageContainer);
              if (typeof setupDynamicLayoutObservers === 'function') {
                setupDynamicLayoutObservers();
              }
              dispatchAppInitEvents(embeddedPageContainer);
            } else {
              if (doc.body && doc.body.innerHTML.trim().length > 0) {
                embeddedPageContainer.innerHTML = `<p>${uiText.errorContentNotFoundLabel} <a href="${url}" target="_blank">${uiText.openPageDirectlyLabel}</a></p><p style="font-size:0.8em; color: #666;">${uiText.consoleTipLabel}</p>`;
              } else {
                embeddedPageContainer.innerHTML = `<p>${uiText.errorEmptyPageLabel} <a href="${url}" target="_blank">${uiText.openPageDirectlyLabel}</a></p>`;
              }
            }

            if (typeof maintainConsistentLayout === 'function') {
              maintainConsistentLayout(); // Initial call
              // Add a delayed call to catch layout changes after images/scripts might have run
              setTimeout(() => {
                maintainConsistentLayout();
              }, 750); // 750ms delay, can be adjusted
            }
          })
          .catch(error => {
            embeddedPageContainer.innerHTML = `<p>${uiText.errorLoadingPageLabel} (${error.message}) <a href="${url}" target="_blank">${uiText.openPageDirectlyLabel}</a></p>`;
            if (typeof maintainConsistentLayout === 'function') {
              maintainConsistentLayout(); // Call even on error to set a base height
              setTimeout(() => {
                maintainConsistentLayout();
              }, 750); // Also for error case
            }
          });
        if (!options.skipUrlUpdate) {
          syncUrlWithCurrentState({ replace: options.replaceHistory });
        }
        updateBreadcrumbs();
      }

      // Shows a pre-rendered rich text block
      function showRichTextContent(blockId, cardElement, options = {}) {
        topicGrid.classList.add('hidden');
        const cardTitleText = cardElement.querySelector('.topic-card-title').textContent.trim();
        const selectedItem = getHelpdeskItemByCardElement(cardElement);
        const trailFromOptions = sanitizeFolderTrail(options.folderTrail);
        if (trailFromOptions.length) {
          currentFolderTrail = trailFromOptions;
        } else {
          const parentFolderHandle = selectedItem ? getItemParentFolderHandle(selectedItem) : '';
          const activeFolderHandle = getCurrentFolderHandle();
          if (!parentFolderHandle) {
            currentFolderTrail = [];
          } else if (parentFolderHandle !== activeFolderHandle) {
            const parentFolderItem = allHelpdeskItems.find(
              (item) => item.type === 'folder' && getItemOwnFolderHandle(item) === parentFolderHandle
            );
            currentFolderTrail = buildFolderTrailFromFolderItem(parentFolderItem);
          }
        }

        currentArticleTitle = cardTitleText;
        currentArticleSlug = selectedItem ? getItemRouteSlug(selectedItem) : slugify(cardTitleText);

        embeddedPageContent.style.display = 'none'; // Hide fetched page area
        
        // Hide all individual rich text contents first
        const allRichTextContents = richTextEmbedDisplay.querySelectorAll('.embedded-rich-text-content');
        allRichTextContents.forEach(content => content.style.display = 'none');
        
        // Show the specific rich text content
        const targetRichTextContent = document.getElementById('rt-content-' + blockId);
        if (targetRichTextContent) {
          targetRichTextContent.style.display = 'block';
        }
        
        richTextEmbedDisplay.style.display = 'block'; // Show rich text container
        pageContentContainer.classList.remove('hidden');

        scrollToHelpdeskTop();
        if (typeof setupDynamicLayoutObservers === 'function') {
          setupDynamicLayoutObservers();
        }
        maintainConsistentLayout();
        dispatchAppInitEvents(targetRichTextContent || richTextEmbedDisplay);
        if (!options.skipUrlUpdate) {
          syncUrlWithCurrentState({ replace: options.replaceHistory });
        }
        updateBreadcrumbs();
      }
      
      // Add click handlers to topic cards
      topicCards.forEach(card => {
        card.addEventListener('click', function(event) {
          const cardType = this.dataset.type;

          if (cardType === 'page-embed') {
            const pageUrl = this.dataset.page;
            if (pageUrl) {
              event.preventDefault(); // Prevent default if it's somehow an anchor
              showPage(pageUrl, this);
            }
          } else if (cardType === 'rich-text-embed') {
            const blockId = this.dataset.blockId;
            if (blockId) {
              event.preventDefault();
              showRichTextContent(blockId, this);
            }
          } else if (cardType === 'folder') {
            event.preventDefault();
            const folderHandle = this.dataset.folder;
            const folderTitle = this.querySelector('.topic-card-title').textContent;
            const folderItem = getHelpdeskItemByCardElement(this);
            const folderTrail = buildFolderTrailFromFolderItem(folderItem);
            showFolderContents(folderHandle, folderTitle, { folderTrail });
          }
          // For 'page-redirect', default <a> behavior will handle the navigation
        });
      });
      
      // Add click handlers to back buttons
      backButtons.forEach(button => {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          if (currentArticleTitle && currentFolderTrail.length) {
            const targetFolder = currentFolderTrail[currentFolderTrail.length - 1];
            showFolderContents(targetFolder.handle, targetFolder.title, { folderTrail: currentFolderTrail });
          } else if (currentArticleTitle) {
            showHome();
          } else if (currentFolderTrail.length > 1) {
            const parentTrail = currentFolderTrail.slice(0, -1);
            const parentFolder = parentTrail[parentTrail.length - 1];
            showFolderContents(parentFolder.handle, parentFolder.title, { folderTrail: parentTrail });
          } else if (currentFolderTrail.length === 1) {
            showHome();
          } else {
            showHome();
          }
        });
      });
      
      window.addEventListener('resize', maintainConsistentLayout);
      window.addEventListener('popstate', () => {
        applyRouteFromLocation({ skipUrlUpdate: true });
      });
      maintainConsistentLayout(); // Initial call
      if (typeof setupDynamicLayoutObservers === 'function') {
        setupDynamicLayoutObservers(); // Start observing for dynamic changes
      }
      applyRouteFromLocation({ replaceHistory: true });
  });

  } catch(e) { console.error(e); }
})();
})();
